<template>
  <v-app>
    <v-container fluid style="margin-top: 0%; padding: 0% 0% 0 0;">
      <v-row style="height: 100%; margin: 0; padding: 0; position: relative">
        <v-col cols="12" class="pa-0">
          <GlobalNav />
        </v-col>
        <v-col cols="12" class="pa-0 d-flex align-start ga-6">
          <SideBar />
          <div class="w-100 pa-3 is-light-mode">
            <BreadCrumb :linksData="linksData" class="mb-3" />
            <div class="d-flex align-center ga-2 tabs mt-5">
              <div class="tab active">Roles</div>
              <div class="tab cursor-pointer" @click="$router.push({ name: 'AllUsers' })">
                Users
              </div>
            </div>
            <div class="d-flex align-center justify-end ga-2 mt-5">
              <span class="show-all-btn cursor-pointer" @click="$router.push({ name: 'AllRoles' })">Show all Roles
                permissions</span>
              <span :disabled="!$permissionsFor('my-team').create"
                :class="{ 'read-only': !$permissionsFor('my-team').create }" class="add-new-btn cursor-pointer"
                @click="$router.push({ name: 'NewRole' })">Add New Role</span>
            </div>
            <div class="mt-5">
              <v-table>
                <thead>
                  <tr>
                    <th class="text-left">ID</th>
                    <th class="text-left">Role</th>
                    <th class="text-left">Persons</th>
                    <th class="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="role in roles" :key="role">
                    <td>{{ role.id }}</td>
                    <td>{{ role.name }}</td>
                    <td>
                      <span class="d-flex align-center">
                        <img v-for="person in role.users.slice(0, 4)" :key="person.id" :title="person.name" width="40"
                          height="40" class="circle-img mr-2" :src="person.image" :alt="person.name" />
                      </span>
                    </td>
                    <td>
                      <span class="d-flex aligncenter ga-2">
                        <svg :disabled="role.name === 'Super Admin'" :class="[role.name === 'Super Admin' ? 'read-only' : '', { 'read-only': !$permissionsFor('my-team').update }]" @click="
                          $router.push({
                            name: 'EditRole',
                            params: { id: role.id },
                          })
                          " class="cursor-pointer" width="16" height="16" viewBox="0 0 16 16" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5780_25679)">
                            <path
                              d="M11.332 2.00004C11.5071 1.82494 11.715 1.68605 11.9438 1.59129C12.1725 1.49653 12.4177 1.44775 12.6654 1.44775C12.913 1.44775 13.1582 1.49653 13.387 1.59129C13.6157 1.68605 13.8236 1.82494 13.9987 2.00004C14.1738 2.17513 14.3127 2.383 14.4074 2.61178C14.5022 2.84055 14.551 3.08575 14.551 3.33337C14.551 3.58099 14.5022 3.82619 14.4074 4.05497C14.3127 4.28374 14.1738 4.49161 13.9987 4.66671L4.9987 13.6667L1.33203 14.6667L2.33203 11L11.332 2.00004Z"
                              stroke="#666666" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5780_25679">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg :disabled="role.name === 'Super Admin'" :class="[role.name === 'Super Admin' ? 'read-only' : '', { 'read-only': !$permissionsFor('my-team').delete }]" @click="
                          deleted_id = role.id;
                        deleteDialog = true;
                        " class="cursor-pointer" width="16" height="16" viewBox="0 0 16 16" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5780_25681)">
                            <path
                              d="M14.9527 2.105H11.2777V1.61775C11.2772 1.18883 11.1066 0.777618 10.8033 0.474334C10.5 0.17105 10.0888 0.000463179 9.65987 0H6.34363C5.91472 0.000487988 5.50352 0.171086 5.20024 0.474367C4.89696 0.777648 4.72636 1.18885 4.72587 1.61775V2.105H1.05078C0.926461 2.105 0.807233 2.15439 0.719325 2.24229C0.631417 2.3302 0.582031 2.44943 0.582031 2.57375C0.582031 2.69807 0.631417 2.8173 0.719325 2.90521C0.807233 2.99311 0.926461 3.0425 1.05078 3.0425H1.71259V13.1488C1.71341 13.9047 2.01405 14.6294 2.54855 15.1639C3.08306 15.6985 3.80777 15.9991 4.56369 16H11.4398C12.1957 15.9991 12.9204 15.6985 13.4549 15.164C13.9894 14.6295 14.2901 13.9048 14.2909 13.1489V3.0425H14.9527C15.077 3.0425 15.1963 2.99311 15.2842 2.90521C15.3721 2.8173 15.4215 2.69807 15.4215 2.57375C15.4215 2.44943 15.3721 2.3302 15.2842 2.24229C15.1963 2.15439 15.077 2.105 14.9527 2.105ZM5.66337 1.61775C5.66358 1.4374 5.73532 1.2645 5.86284 1.13697C5.99037 1.00944 6.16328 0.937707 6.34363 0.9375H9.65987C9.84023 0.937707 10.0131 1.00944 10.1407 1.13697C10.2682 1.2645 10.3399 1.4374 10.3401 1.61775V2.105H5.66337V1.61775ZM13.3534 13.149C13.3528 13.6563 13.151 14.1427 12.7923 14.5014C12.4335 14.8601 11.9471 15.0619 11.4398 15.0625H4.56369C4.05634 15.0619 3.56994 14.8601 3.2112 14.5014C2.85246 14.1426 2.65066 13.6562 2.65009 13.1489V3.0425H13.3534V13.149ZM7.533 12.3355V5.03716C7.533 4.91284 7.58239 4.79361 7.67029 4.7057C7.7582 4.61779 7.87743 4.56841 8.00175 4.56841C8.12607 4.56841 8.2453 4.61779 8.33321 4.7057C8.42111 4.79361 8.4705 4.91284 8.4705 5.03716V12.3355C8.4705 12.4598 8.42111 12.579 8.33321 12.6669C8.2453 12.7548 8.12607 12.8042 8.00175 12.8042C7.87743 12.8042 7.7582 12.7548 7.67029 12.6669C7.58239 12.579 7.533 12.4598 7.533 12.3355ZM10.7583 11.5268V5.84578C10.7583 5.72146 10.8077 5.60223 10.8956 5.51433C10.9835 5.42642 11.1027 5.37703 11.227 5.37703C11.3514 5.37703 11.4706 5.42642 11.5585 5.51433C11.6464 5.60223 11.6958 5.72146 11.6958 5.84578V11.5268C11.6958 11.6511 11.6464 11.7704 11.5585 11.8583C11.4706 11.9462 11.3514 11.9956 11.227 11.9956C11.1027 11.9956 10.9835 11.9462 10.8956 11.8583C10.8077 11.7704 10.7583 11.6511 10.7583 11.5268ZM4.30772 11.5268V5.84578C4.30772 5.72146 4.3571 5.60223 4.44501 5.51433C4.53292 5.42642 4.65215 5.37703 4.77647 5.37703C4.90079 5.37703 5.02002 5.42642 5.10792 5.51433C5.19583 5.60223 5.24522 5.72146 5.24522 5.84578V11.5268C5.24522 11.6511 5.19583 11.7704 5.10792 11.8583C5.02002 11.9462 4.90079 11.9956 4.77647 11.9956C4.65215 11.9956 4.53292 11.9462 4.44501 11.8583C4.3571 11.7704 4.30772 11.6511 4.30772 11.5268Z"
                              fill="#CC0000" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5780_25681">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <v-dialog v-model="deleteDialog" width="auto">
    <v-card max-width="550">
      <template v-slot:text>
        <div>
          <div class="d-flex justify-space-between align-center mb-8">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="4.5" width="48" height="48" rx="24" fill="#FEE4E2" />
              <rect x="4" y="4.5" width="48" height="48" rx="24" stroke="#FEF3F2" stroke-width="8" />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg @click="deleteDialog = false" width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg" class="cursor-pointer hoverd">
              <path d="M18 6L6 18M6 6L18 18" stroke="#717680" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div class="delete-dialog-body">
            <div class="main mb-2">
              Are you sure you want to delete this item
            </div>
            <div class="sub">
              If you deleted this item you won’t be able to restore it again
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="pa-4 d-flex align-center ga-3">
          <v-btn class="cancel-btn" text="Cancel" @click="deleteDialog = false"></v-btn>
          <v-btn class="delete-btn text-capitalize" color="white" text="Delete" @click="deleteRole"></v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import "@/assets/css/team/style.css";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General";
export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
  },

  data() {
    return {
      linksData: [
        { name: "Home", link: "/" },
        { name: "My Team", link: "" },
      ],
      roles: [],
      deleted_id: null,
      deleteDialog: false,
      general_store: useGeneralStore(),
    };
  },

  methods: {
    getAllRoles() {
      apiClient
        .get("/my-team/list-roles-users")
        .then((response) => {
          this.roles = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        });
    },
    deleteRole() {
      apiClient
        .post(`/my-team/delete-role`, { role_id: this.deleted_id })
        .then(() => {
          this.getAllRoles();
          this.deleteDialog = false;
          this.general_store.showSnackbar(
            "Role Deleted Successfully",
            "success"
          );
        })
        .catch((error) => {
          this.deleteDialog = false;
          this.general_store.showSnackbar("Failed to delete role", "error");
        });
    },
  },

  mounted() {
    this.getAllRoles();
  },
};
</script>
